module.exports = __webpack_public_path__ + "img/Doc15a_19830409-005_front.7934116e.jpg";